import React from 'react';
import { compose, withHandlers } from 'recompose';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddReservationForm from './form/addForm';
import { createFastItemService } from './_api';
import { withSnackbar } from 'notistack';
import moment from 'moment';

const styles = (theme) => ({
  root: {
    margin: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withLoader,
  withRouter,
  withSnackbar,
  withHandlers({
    onSubmit:
      ({ history, toggleLoader, enqueueSnackbar }) =>
      async (values) => {
        toggleLoader();
        const resp = await createFastItemService({
          ...values,
          adjustment: undefined,
          completionDate: moment(values.completionDate).format('YYYY-MM-DD HH:mm:ss'),
          itemAttributes: values.itemAttributes ? JSON.stringify(values.itemAttributes) : '',
          itemAdjustment: values.adjustment
            ? values.itemAdjustment
              ? JSON.stringify(values.itemAdjustment)
              : ''
            : '',
          serviceAttributes: values.serviceAttributes
            ? JSON.stringify(values.serviceAttributes)
            : '',
        });
        if (get(resp, 'success', false)) {
          enqueueSnackbar('Servis byl úspěšně vytvořen.', {
            variant: 'success',
          });
          history.push('/item-services/list');
        } else {
          enqueueSnackbar('Servis se nepodařilo vytvořit.', {
            variant: 'error',
          });
          console.log(resp.data);
        }
        toggleLoader(false);
      },
  })
);

export default enhance(({ classes, onSubmit, users, handleTabChange }) => (
  <div className={classes.root}>
    <Paper className={classes.paper}>
      <AddReservationForm onSubmit={onSubmit} users={users} handleTabChange={handleTabChange} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/item-services/add.js